// SkeletonElements.js
export const SkeletonBox = ({ width, height, style }) => (
    <div style={{ width, height, backgroundColor: '#ccc', ...style }}></div>
);

export const SkeletonLine = ({ width, style }) => (
    <SkeletonBox width={width} height="20px" style={{ marginBottom: '10px', ...style }} />
);
